var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgConfigurable = function SvgConfigurable(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 49,
    viewBox: "0 0 42 49",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.74 0L41.48 12.2V36.6L20.74 48.8L0 36.6V12.2L20.74 0ZM20.74 5.63396L4.78728 15.0182V33.7794L20.74 43.1636L36.6903 33.7794V15.0182L20.74 5.63396ZM20.352 14.64C25.642 14.64 29.9315 19.0076 29.9315 24.4C29.9315 29.7924 25.642 34.16 20.352 34.16C15.0621 34.16 10.7726 29.7924 10.7726 24.4C10.7726 19.0076 15.0646 14.64 20.352 14.64ZM20.352 19.52C17.7071 19.52 15.5623 21.7038 15.5623 24.4C15.5623 27.0962 17.7095 29.28 20.352 29.28C22.997 29.28 25.1418 27.0962 25.1418 24.4C25.1418 21.7038 22.997 19.52 20.352 19.52Z",
    fill: "#031FEF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConfigurable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/configurable.c40f8c4d.svg";
export { ForwardRef as ReactComponent };